import React from 'react'
import { LegalPage } from '@/components/legal/LegalPage'

export const TermsPage: React.FC = () => (
  <LegalPage
    titleKey="legal.terms.title"
    sections={[
      { titleKey: 'legal.terms.objectTitle', contentKey: 'legal.terms.object' },
      { titleKey: 'legal.terms.registrationTitle', contentKey: 'legal.terms.registration' },
      { titleKey: 'legal.terms.useTitle', contentKey: 'legal.terms.use' },
      { titleKey: 'legal.terms.contentTitle', contentKey: 'legal.terms.content' },
      { titleKey: 'legal.terms.contributionsTitle', contentKey: 'legal.terms.contributions' },
      { titleKey: 'legal.terms.liabilityTitle', contentKey: 'legal.terms.liability' },
      { titleKey: 'legal.terms.suspensionTitle', contentKey: 'legal.terms.suspension' },
      { titleKey: 'legal.terms.changesTitle', contentKey: 'legal.terms.changes' },
    ]}
  />
)
